import { Button, Checkbox, FormControlLabel, Grid, ListItemText, Paper, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Api } from '../providers/Api';
import { User } from '../atoms/user';
import { userAtom } from '../atoms/userAtom';
import { useAtomValue } from 'jotai';

const ListUsers = () => {
    const [users, setUsers] = useState(null as User[]);
    const [add, setAdd] = useState(false);
    const [userName, setUserName] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);

    const user = useAtomValue(userAtom);
    useEffect(() => {

        let api = new Api();
        api.listUsers().then((data) => {
            setUsers(data);
        });
    }, []);

    const addUser = () => {
        let api = new Api();
        api.addUser(userName, isAdmin).then((x) => {
            api.listUsers().then((data) => {
                setUsers(data);
            });
            setAdd(false);
            setUserName('');
            setIsAdmin(false);
        })

    };
     const delUser = (user: string) => {
        let api = new Api();
        api.removeUser(user).then((x) => {
            api.listUsers().then((data) => {
                setUsers(data);
            });
            setAdd(false);
            setUserName('');
            setIsAdmin(false);
        })

    };

    return <Stack style={{ padding: 10 }}>
        <Button onClick={() => { setAdd(true); }} variant='contained'>Lägg till användare</Button>
        <Grid container style={{ marginTop: 10 }}>
            {add && <>
                <Grid xs={6}><TextField fullWidth placeholder='Användarnamn' value={userName} onChange={(ev) => { setUserName(ev.target.value); }} /></Grid>
                <Grid xs={3}><FormControlLabel label={"Admin?"} control={<Checkbox checked={isAdmin} onChange={(ev) => { setIsAdmin(ev.target.checked); }} />} /></Grid>
                <Grid xs={3}><Button variant='contained' onClick={() => { addUser() }} disabled={!userName}>Spara</Button></Grid>
            </>
            }
            {!add && <>
                <Grid item xs={10} style={{ background: '#ccc' }}>
                    <Typography variant='body2'><b>Namn</b></Typography>
                </Grid>
                <Grid item xs={2} style={{ background: '#ccc' }}>

                </Grid>
                {users && users.map((u) => {
                    return <>
                        <Grid item xs={12}>
                            <Stack direction={'row'}><Button onClick={() => {
                                delUser(u.id);
                            }} variant='contained' disabled={u.id == user.id}>Ta bort</Button><Typography variant='body2' style={{ lineHeight: '36px', marginLeft: 10 }}>{u.id}</Typography></Stack>
                        </Grid>
                    </>;
                })}
            </>}
        </Grid>
    </Stack>;
}
export default ListUsers;